import { LocaleEnum } from '@systemeio/ui'

export const getHelpPageLinkGoogleCalendar = (locale?: LocaleEnum) => {
  switch (locale) {
    default: {
      return 'https://help.systeme.io/article/4273-how-to-integrate-google-calendar-with-systemeio'
    }
  }
}
